<div class="d-inline-flex">
  <ncp-button
    #addLabReportButton
    [options]="btnOptions()"
  >
    <img
      [ngSrc]="assets.healthIcons.svg.outline.symbols.diagnostics.src"
      width="18"
      height="18"
      alt="Add Lab Report"
      class="healthIcon"
    />
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="lab_report_form"
      name="lab_report_form"
      [formGroup]="form"
      #frm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown
        #labDD
        [(options)]="labOptions"
      />

      <ncp-input [(options)]="authorInputOptions" />

      <ncp-dropdown
        #specialtyDD
        [(options)]="specialtyOptions"
      />

      <ncp-date
        #onsetDate
        [(options)]="dateOptions"
      />

      <div>
        <label for="labReportFile" class="form-label">
          {{ 'input.labels.select_file' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          id="labReportFile"
          #documentFileInput
          type="file"
          class="form-control"
          accept="application/pdf"
          [formControl]="file"
          (change)="onFileSelected($event)"
        />
        @if(documentFileName) {
          <small class="text-muted">
            Selected: {{ documentFileName }}
          </small>
        }
      </div>
    </form>
  </ncp-modal>
</div>
